

// ── Workspace detail ───────────────────────────────────────────────────────────
export type PlanDetailTab = 'summary' | 'findings' | 'policy' | 'providers'

export const PLAN_TAB_LABEL: Record<PlanDetailTab, string> = {
  summary: 'Summary / Drift',
  findings: 'Findings',
  policy: 'Policy',
  providers: 'Providers',
}

